import { useMutation } from '@tanstack/react-query';
import useToast from 'services/Hooks/useToast';
import axios from 'axios';

export const useDownloadFile = fileUrl => {
  const { errorMessage } = useToast();
  const query = useMutation({
    mutationKey: ['downloadFile'],
    mutationFn: async () => {
      return await axios.get(fileUrl, {
        responseType: 'blob',
        headers: {
          'Content-Disposition': 'attachment',
        },
      });
    },
    onSuccess: response => {
      const href = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = href;
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(response.headers['content-disposition']);
      if (matches != null && matches[1]) {
        link.setAttribute('download', matches[1].replace(/['"]/g, ''));
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    },
    onError: errorMessage,
  });
  return query;
};
